import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import ConfigurationConstants from "../../utils/configurationconstants";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { useEffect, useState } from "react";

export const useGetPatientDetailsByIdentifier = (identifier) => {
  const configuration = useRecoilValue(currentConfiguration);
  const secretKey = configuration[ConfigurationConstants.NIRAMAYA_ORGANIZATION_SECRETKEY];
  const [patientDetails, setPatientDetails] = useState({});
  const [patientDetailsLoading, setPatientDetailsLoading] = useState(false);

  const getPatientDetails = async () => {
    setPatientDetailsLoading(true);
    const payload = {
      userIdentifier: identifier,
      secretKey: secretKey?.key,
    };
    const userData = await executeIntent(IntentType.GET_PATIENT_DETAILS_BY_USER_IDENTIFIER, payload);
    setPatientDetails(userData[0]);
    setPatientDetailsLoading(false);
  }

  useEffect(() => {
    getPatientDetails();
  }, [configuration, secretKey, identifier]);

  return [patientDetails, patientDetailsLoading];
}